import React from "react";
import ComponentCard from "../../../components/common/ComponentCard";
import HighlightListComponent from "../../../components/slider/HighlightListComponent";
import PageMeta from "../../../components/common/PageMeta";

const HighlightList = () => {

    return (
        <>
            <PageMeta title="Highlight" description="Trang highlight" />
            <div className="space-y-6">
                <ComponentCard title="">
                    <HighlightListComponent />
                </ComponentCard>
            </div>
        </>
    );
};

export default HighlightList;
